// extracted by mini-css-extract-plugin
export default {"operator":"DropdownRange_operator__-4ClV"};